import { useEffect } from "react";
import { useScrollContext } from "../contexts/ScrollContextProvider";

export const useScroll = () => {
  const { isScrolled, setIsScrolled } = useScrollContext();

  //   useEffect(() => {
  //     const handleScroll = () => {
  //       setIsScrolled(window.scrollY > 0);
  //     };

  //     window.addEventListener("scroll", handleScroll);

  //     return () => {
  //       window.removeEventListener("scroll", handleScroll);
  //     };
  //   }, []);
  useEffect(() => {
    const handleScroll = () => {
      if (!isScrolled && window.scrollY > 0) {
        setIsScrolled(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isScrolled, setIsScrolled]);

  return { isScrolled };
};
